import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { NumericCodeAndName } from '@lx/shared/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LocalizeAndPluralizePeriodPipe } from '@lx/shared/ui/pipes';
import { FormFieldSelectorComponent } from '../form-field-selector/form-field-selector.component';
import { DEFAULT_WEEKS_RANGE } from '@lx/shared/utils';

@Component({
  standalone: true,
  selector: 'lx-weeks-selector',
  templateUrl: './weeks-selector.component.html',
  styleUrls: ['./weeks-selector.component.scss'],
  imports: [FormFieldSelectorComponent],
  providers: [LocalizeAndPluralizePeriodPipe],
})
export class WeeksSelectorComponent implements OnChanges {
  @Input() label: string;
  @Input() disabled = false;
  @Input() value: number | undefined;
  @Input() minWeeks = DEFAULT_WEEKS_RANGE.MIN_WEEKS;
  @Input() maxWeeks = DEFAULT_WEEKS_RANGE.MAX_WEEKS;
  @Input() availableWeeksValues: number[] = [];
  @Input() placeholder: string;
  @Input() required = false;
  @Input() autofill = true;
  @Input() iconValidation = false;
  @Output() valueChange = new EventEmitter<number>();
  @Output() itemChange = new EventEmitter<NumericCodeAndName>();

  public weeksOptions: NumericCodeAndName[] = [];
  private readonly localizeAndPluralizePeriodPipe = inject(LocalizeAndPluralizePeriodPipe);

  ngOnChanges({ availableWeeksValues }: SimpleChanges) {
    if (this.availableWeeksValues?.length) {
      if (availableWeeksValues) {
        this.buildWeeksOptions(this.availableWeeksValues);
      }
    } else {
      this.buildWeeksOptions(this.availableWeeksValuesBetweenMinAndMax());
    }
  }

  private availableWeeksValuesBetweenMinAndMax(): number[] {
    return [...Array((this.maxWeeks ?? DEFAULT_WEEKS_RANGE.MAX_WEEKS) + 1).keys()].slice(Math.max(this.minWeeks ?? DEFAULT_WEEKS_RANGE.MIN_WEEKS, 1));
  }

  private buildWeeksOptions(availableWeeksValues: number[]) {
    this.weeksOptions = availableWeeksValues?.map((i) => ({ code: i, name: this.localizeAndPluralizePeriodPipe.transform(i) }));
  }
}
